import { lazy } from "react";

export default {
  name: "Home",
  path: "/",
  component: lazy(() => import("./index"))
}